import { FaIdBadge, FaMap, FaStar, FaTruck } from "react-icons/fa";

interface StatCardProps {
  icon: React.ReactNode;
  title: string;
  description: string;
  colorBg?: string;
  colorText?: string;
}
const StatCard = ({
  icon,
  title,
  description,
  colorBg = "bg-white",
  colorText = "text-n-text-green",
}: StatCardProps) => (
  <div
    className={`flex flex-col justify-center  ${colorBg} md:max-w-[304px] max-w-[280px] p-5 rounded-2xl shadow-sm hover:shadow-lg transition-all duration-300`}
  >
    <div className={`${colorText} mb-5`}>{icon}</div>
    <h3 className={`font-semibold ${colorText} text-2xl mb-2`}>{title}</h3>
    <p className={` ${colorText} mb-2`}>{description}</p>
  </div>
);

export const StatsSection = () => {
  return (
    <section className=" py-8 md:py-16">
      <div className="container items-center">
        <div className="flex flex-row flex-wrap justify-evenly gap-4">
          <StatCard
            icon={<FaStar className="w-8 h-8" />}
            title="+ de 750.000 clientes atendidos"
            description="Satisfação de nossos clientes em todo o Brasil."
            colorBg="bg-n-bg-green"
            colorText="text-n-text-beige"
          />
          <StatCard
            icon={<FaTruck className="w-8 h-8" />}
            title="+ 200 mil veículos transportados"
            description="Volume que confirma a qualidade do nosso serviço."
            colorBg="bg-n-secondary"
          />
          <StatCard
            icon={<FaMap className="w-8 h-8" />}
            title="+ de 200 bases pelo Brasil"
            description="Proximidade do seu local. Pronto para atender em qualquer região."
            colorBg="bg-n-beige"
          />
          <StatCard
            icon={<FaIdBadge className="w-8 h-8" />}
            title="+ de 10.000 transportadores credenciados"
            description="Capacitados para atender você em qualquer operação."
            colorBg="bg-n-green-s-light"
          />
        </div>
      </div>
    </section>
  );
};
